import InputText from './InputText.vue';

// @ts-ignore
InputText.install = (Vue) => {
  Vue.component((InputText as any).options.name, InputText);
};

export default InputText;
